/*
 * @Author: bbqin
 * @Date: 2022-03-02 16:26:23
 * @LastEditTime: 2022-07-12 15:40:00
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\CreateDragWidthCom\output.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import * as API from "./compatible";
import CreateDragWidthCom from "./index";
export default function compatible() {
    this.register("createDragWidthCom");
    return {
        store: CreateDragWidthCom.useCreateDragWidthCom,
        ...apiBindPage.call(this, API),
    };
}

function apiBindPage(API) {
    let res = {};
    for (let pop of Object.keys(API)) {
        res[pop] = API[pop].bind(this);
    }
    return res;
}

compatible.component = CreateDragWidthCom;
compatible.displayName = "CreateDragWidthCom";
compatible.unfinished = [];